/*import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import type { Result } from "@zxing/library";

interface BarcodeScannerProps {
  onDetected: (code: string) => void;
}

export default function BarcodeScanner({ onDetected }: BarcodeScannerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    let active = true;

    async function startScanner() {
      try {
        if (videoRef.current) {
          await codeReader.decodeFromVideoDevice(
            null,
            videoRef.current,
            (result: Result | null, err: Error | null) => {
              if (!active) return;

              if (result) {
                console.log("Detected barcode:", result.getText());
                onDetected(result.getText());
                codeReader.reset(); // prevent duplicate scans
              }

              if (err && err.name !== "NotFoundException") {
                console.error("Scanner error:", err);
                setError(err.message);
              }
            }
          );
        }
      } catch (err: any) {
        setError(err.message);
      }
    }

    startScanner();

    return () => {
      active = false;
      codeReader.reset();
    };
  }, [onDetected]);

  return (
    <div>
      <video
        ref={videoRef}
        className="w-full rounded shadow"
        autoPlay
        playsInline
      />
      {error && <p className="text-danger mt-2">{error}</p>}
    </div>
  );
}
*/
// src/components/BarcodeScanner.tsx
// src/components/BarcodeScanner.tsx
// src/components/BarcodeScanner.tsx
/*
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import type { Result } from "@zxing/library";
import { notifyError, notifySuccess } from "../services/toast";
import ProductInfoModal from "./ProductInfoModal";

interface BarcodeScannerProps {
  onDetected?: (code: string) => void; // ✅ declare prop
}

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onDetected }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scanning, setScanning] = useState(true);
  const [lastCode, setLastCode] = useState<string | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [fallbackMode, setFallbackMode] = useState(false);

  // 🔐 Camera permission + attach stream
  useEffect(() => {
    if (!navigator.mediaDevices?.getUserMedia) {
      notifyError("Camera not supported, switching to keyboard scanner");
      setFallbackMode(true);
      return;
    }

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.muted = true;
          videoRef.current
            .play()
            .then(() => setLoading(false))
            .catch(() => {
              notifyError("Unable to start video playback, fallback enabled");
              setFallbackMode(true);
            });
        }
        setAllowed(true);
      })
      .catch(() => {
        notifyError("Camera permission denied, fallback enabled");
        setFallbackMode(true);
      });
  }, []);

  // 📷 Barcode scanning
  useEffect(() => {
    if (!allowed || !videoRef.current || !scanning || fallbackMode) return;

    const reader = new BrowserMultiFormatReader();

    reader.decodeFromVideoDevice(
      null,
      videoRef.current,
      async (result: Result | null) => {
        if (result) {
          const code = result.getText();
          if (code && code !== lastCode) {
            setLastCode(code);
            notifySuccess(`Barcode detected: ${code}`);

            if (onDetected) {
              await onDetected(code); // ✅ pass up to parent (POS)
            } else {
              // Standalone lookup
              try {
                const res = await fetch(`/api/products/barcode/${encodeURIComponent(code)}`);
                const data = await res.json();
                if (data) {
                  setSelectedProduct(data);
                } else {
                  notifyError("Product not found");
                }
              } catch {
                notifyError("Error fetching product");
              }
            }

            setScanning(false);
            reader.reset();
          }
        }
      }
    );

    return () => {
      reader.reset();
    };
  }, [allowed, scanning, onDetected, lastCode, fallbackMode]);

  if (fallbackMode) {
    return (
      <div className="scanner-container text-center">
        <p className="text-muted">Camera unavailable. Using keyboard scanner.</p>
        <p className="small">Scan with a USB barcode scanner or type manually.</p>
      </div>
    );
  }

  if (!allowed) {
    return <p className="text-muted">Camera permission required</p>;
  }

  return (
    <div className="scanner-container text-center position-relative">
      {loading && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading camera...</span>
          </div>
        </div>
      )}

      <video
        ref={videoRef}
        className="w-100 rounded shadow border"
        autoPlay
        playsInline
      />

      <div
        className="position-absolute top-50 start-50 translate-middle border border-danger"
        style={{ width: "60%", height: "30%" }}
      ></div>

      {!scanning && (
        <button
          className="btn btn-primary mt-3"
          onClick={() => {
            setScanning(true);
            setLastCode(null);
            setSelectedProduct(null);
          }}
        >
          Scan Again
        </button>
      )}

      {selectedProduct && (
        <ProductInfoModal
          product={selectedProduct}
          show={true}
          onClose={() => setSelectedProduct(null)}
        />
      )}
    </div>
  );
};

export default BarcodeScanner;

*/
/*
//C:\xampp\htdocs\pms2\frontend\src\components\BarcodeScanner.tsx
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import type { Result } from "@zxing/library";
import { notifyError, notifyInfo, notifySuccess } from "../services/toast";
import ProductInfoModal from "./ProductInfoModal";
import { validateBarcode } from "../utils/barcodeValidation";
import { logScanEvent } from "../services/scanAnalytics";
import { getCachedProduct, setCachedProduct } from "../services/offlineCache";
import { speak } from "../utils/voice";

interface BarcodeScannerProps {
  onDetected?: (code: string) => Promise<void> | void;
}

const SCAN_TIMEOUT = 15000; // 15 seconds
const SCAN_INTERVAL = 500; // ms

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onDetected }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const readerRef = useRef<InstanceType<typeof BrowserMultiFormatReader> | null>(null);

  const lastScanTime = useRef<number>(0);

  const [status, setStatus] = useState<
    "initializing" | "ready" | "scanning" | "success" | "error" | "fallback"
  >("initializing");

  const [message, setMessage] = useState("Initializing camera...");
  const [lastCode, setLastCode] = useState<string | null>(null);
  const [product, setProduct] = useState<any | null>(null);

  /* ────────────────────────────────────────────── /
  /* CAMERA INITIALIZATION /
  /* ────────────────────────────────────────────── /
  useEffect(() => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setStatus("fallback");
      notifyError("Camera not supported");
      return;
    }

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
        },
      })
      .then((stream) => {
        if (!videoRef.current) return;

        videoRef.current.srcObject = stream;
        videoRef.current.setAttribute("playsinline", "true");

        videoRef.current.onloadedmetadata = () => {
          videoRef.current?.play();
          setStatus("ready");
          setMessage("Align barcode inside the frame");
        };
      })
      .catch(() => {
        setStatus("fallback");
        notifyError("Camera permission denied");
      });
  }, []);

  /* ────────────────────────────────────────────── */
  /* BARCODE DECODING */
  /* ────────────────────────────────────────────── /
  useEffect(() => {
    if (status !== "ready" || !videoRef.current) return;

    readerRef.current = new BrowserMultiFormatReader();
    setStatus("scanning");

    const startTime = Date.now();

    readerRef.current.decodeFromVideoDevice(
      null,
      videoRef.current,
      async (result: Result | null) => {
        const now = Date.now();

        // Throttle decoding
        if (now - lastScanTime.current < SCAN_INTERVAL) return;
        lastScanTime.current = now;

        // Timeout
        if (now - startTime > SCAN_TIMEOUT) {
          setStatus("error");
          setMessage("No barcode detected. Try adjusting distance or lighting.");
          readerRef.current?.reset();
          return;
        }

        if (!result) return;

        const code = result.getText();
        if (!code || code === lastCode) return;
        setLastCode(code);

        // ────────────── VALIDATION & LOGGING ──────────────
        const validation = validateBarcode(code);
        if (!validation.valid) {
          logScanEvent({ type: "invalid", timestamp: Date.now(), barcode: code });
          speak("Invalid barcode. Try again.");
          notifyError(validation.reason || "Invalid barcode");
          return;
        }

        logScanEvent({ type: "success", timestamp: Date.now(), barcode: code });
        speak("Product detected");
        setStatus("success");
        setMessage("Barcode detected");

        readerRef.current?.reset();

        // ────────────── CACHE CHECK ──────────────
        const cached = getCachedProduct(code);
        if (cached) {
          setProduct(cached);
          return;
        }

        // ────────────── FETCH PRODUCT ──────────────
        try {
          const res = await fetch(`/api/products/barcode/${encodeURIComponent(code)}`);
          const data = await res.json();

          if (!data) {
            notifyInfo("Product not found");
          } else {
            setCachedProduct(code, data);
            setProduct(data);
          }
        } catch (err) {
          console.error(err);
          notifyError("Failed to fetch product");
        }

        // ────────────── CUSTOM CALLBACK ──────────────
        if (onDetected) {
          await onDetected(code);
        }
      }
    );

    return () => {
      readerRef.current?.reset();
    };
  }, [status, onDetected, lastCode]);

  /* ────────────────────────────────────────────── */
  /* FALLBACK MODE */
  /* ────────────────────────────────────────────── /
  if (status === "fallback") {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Camera unavailable</p>
        <p className="small">Use USB scanner or manual search</p>
      </div>
    );
  }

  /* ────────────────────────────────────────────── */
  /* UI */
  /* ────────────────────────────────────────────── /
  return (
    <div className="scanner-wrapper position-relative text-center">
      <p className="small text-muted mb-2">{message}</p>

      <video ref={videoRef} className="w-100 rounded shadow" muted />

      {/* SCAN FRAME /}
      <div className="scan-frame" />

      {/* LASER LINE /}
      <div className={`laser ${status === "scanning" ? "active" : ""}`} />

      {(status === "error" || status === "success") && (
        <button
          className="btn btn-primary mt-3"
          onClick={() => {
            setLastCode(null);
            setProduct(null);
            setStatus("ready");
            setMessage("Align barcode inside the frame");
          }}
        >
          Scan Again
        </button>
      )}

      {product && (
        <ProductInfoModal
          product={product}
          show
          onClose={() => setProduct(null)}
        />
      )}
    </div>
  );
};

export default BarcodeScanner;

*/
// frontend/src/components/BarcodeScanner.tsx
import React, { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/browser";
import type { Result } from "@zxing/library";
import { notifyError, notifyInfo } from "../services/toast";
import ProductInfoModal from "./ProductInfoModal";
import { validateBarcode } from "../utils/barcodeValidation";
import { logScanEvent } from "../services/scanAnalytics";
import { getCachedProduct, setCachedProduct } from "../services/offlineCache";
import { speak } from "../utils/voice";

interface BarcodeScannerProps {
  onDetected?: (code: string) => Promise<void> | void;
}

const SCAN_TIMEOUT = 15000;
const SCAN_INTERVAL = 500;

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onDetected }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const readerRef = useRef<InstanceType<typeof BrowserMultiFormatReader> | null>(null);

  const lastScanTime = useRef<number>(0);

  const [allowed, setAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState<
    "initializing" | "ready" | "scanning" | "success" | "error" | "fallback"
  >("initializing");

  const [message, setMessage] = useState("Initializing camera...");
  const [lastCode, setLastCode] = useState<string | null>(null);
  const [product, setProduct] = useState<any | null>(null);
const [isScanning, setIsScanning] = useState(true);

  /* ────────────────────────────────────────────── */
  /* STABLE CAMERA INITIALIZATION (from Code 2) */
  /* ────────────────────────────────────────────── */
  useEffect(() => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setStatus("fallback");
      notifyError("Camera not supported");
      return;
    }

    navigator.mediaDevices
      .getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      })
      .then((stream) => {
        if (!videoRef.current) return;

        videoRef.current.srcObject = stream;
        videoRef.current.muted = true;

        videoRef.current
          .play()
          .then(() => {
            setAllowed(true);
            setLoading(false);
            setStatus("ready");
            setMessage("Align barcode inside the frame");
          })
          .catch(() => {
            notifyError("Unable to start video playback");
            setStatus("fallback");
          });
      })
      .catch(() => {
        notifyError("Camera permission denied");
        setStatus("fallback");
      });
  }, []);

  /* ────────────────────────────────────────────── */
  /* BARCODE DECODING (UNCHANGED LOGIC) */
  /* ────────────────────────────────────────────── */
  useEffect(() => {
    if (!allowed || !videoRef.current || !isScanning) return;


    readerRef.current = new BrowserMultiFormatReader();

    const startTime = Date.now();

    readerRef.current.decodeFromVideoDevice(
      null,
      videoRef.current,
      async (result: Result | null) => {
        const now = Date.now();

        if (now - lastScanTime.current < SCAN_INTERVAL) return;
        lastScanTime.current = now;

        if (now - startTime > SCAN_TIMEOUT) {
          setStatus("error");
          setMessage("No barcode detected. Adjust lighting or distance.");
          readerRef.current?.reset();
          return;
        }

        if (!result) return;

        const code = result.getText();
        if (!code || code === lastCode) return;

        setLastCode(code);
setStatus("scanning");
setIsScanning(true);

        /* ───────── VALIDATION ───────── */
        const validation = validateBarcode(code);
        if (!validation.valid) {
          logScanEvent({ type: "invalid", timestamp: Date.now(), barcode: code });
          speak("Invalid barcode");
          notifyError(validation.reason || "Invalid barcode");
          return;
        }

        logScanEvent({ type: "success", timestamp: Date.now(), barcode: code });
        speak("Product detected");

        setStatus("success");
        setMessage("Barcode detected");

        readerRef.current?.reset();
setIsScanning(false);

        /* ───────── CACHE CHECK ───────── */
        const cached = getCachedProduct(code);
        if (cached) {
          setProduct(cached);
        } else {
          try {
            const res = await fetch(
              `/api/products/barcode/${encodeURIComponent(code)}`
            );
            const data = await res.json();

            if (!data) {
              notifyInfo("Product not found");
            } else {
              setCachedProduct(code, data);
              setProduct(data);
            }
          } catch {
            notifyError("Failed to fetch product");
          }
        }

        /* ───────── CALLBACK ───────── */
        if (onDetected) {
          await onDetected(code);
        }
      }
    );

    return () => {
      readerRef.current?.reset();
    };
  }, [allowed, status, onDetected, lastCode]);

  /* ────────────────────────────────────────────── */
  /* FALLBACK MODE */
  /* ────────────────────────────────────────────── */
  if (status === "fallback") {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Camera unavailable</p>
        <p className="small">Use USB scanner or manual search</p>
      </div>
    );
  }

  /* ────────────────────────────────────────────── */
  /* UI */
  /* ────────────────────────────────────────────── */
  return (
    <div className="scanner-wrapper position-relative text-center">
      <p className="small text-muted mb-2">{message}</p>

      {loading && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading camera...</span>
          </div>
        </div>
      )}

      <video
        ref={videoRef}
        className="w-100 rounded shadow"
        autoPlay
        playsInline
        muted
      />

      <div className="scan-frame" />
      <div className={`laser ${status === "scanning" ? "active" : ""}`} />

      {(status === "error" || status === "success") && (
        <button
          className="btn btn-primary mt-3"
          onClick={() => {
  setLastCode(null);
  setProduct(null);
  setIsScanning(true);   // ← add this
  setStatus("ready");
  setMessage("Align barcode inside the frame");
}}
        >
          Scan Again
        </button>
      )}

      {product && (
        <ProductInfoModal
          product={product}
          show
          onClose={() => setProduct(null)}
        />
      )}
    </div>
  );
};

export default BarcodeScanner;


